export interface IconProps {
  size?: number;
  className?: string;
  strokeWidth?: number;
}


export function ImagePlaceholder({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke">
        <rect x="8" y="10" width="32" height="28" rx="3"/>
        <circle cx="17.5" cy="19" r="3"/>
        <path d="M8 31L18 21L25 28L31 22L40 30"/>
      </g>
    </svg>
  );
}

export function ArrowLeft({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(13.502 13.502) scale(0.91861 0.90805)">
      <path d="M12.6213 22.0607L2.12132 11.5607L12.6213 1.06066M2.12132 11.5607H26.1213" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function ArrowRight({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(10.502 13.502) scale(0.91861 0.90805)">
      <path d="M13.5 22.0607L24 11.5607L13.5 1.06066M24 11.5607H0" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function Check({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(10.502 15.000) scale(0.92699 0.84978)">
      <path d="M1.06066 10.0607L10.0607 19.0607L28.0607 1.06066" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function ChevronDown({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(13.502 18.000) scale(0.90805 0.76726)">
      <path d="M22.0607 1.06066L11.5607 11.5607L1.06066 1.06066" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function ChevronLeft({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(19.502 13.502) scale(0.76726 0.90805)">
      <path d="M12.6213 1.06066L2.12132 11.5607L12.6213 22.0607" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function ChevronRight({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(18.000 13.502) scale(0.76726 0.90805)">
      <path d="M1.06066 22.0607L11.5607 11.5607L1.06066 1.06066" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

// Skip-to-first/last-page glyphs for the catalog pager — same chevron shape
// as ChevronLeft/ChevronRight, just doubled up with a fixed offset.
export function ChevronsLeft({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M29 12L18 24L29 36" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M19 12L8 24L19 36" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
    </svg>
  );
}

export function ChevronsRight({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M19 12L30 24L19 36" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M29 12L40 24L29 36" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
    </svg>
  );
}

export function Clock({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(10.502 10.502) scale(0.89984 0.89984)">
      <path d="M15 6V15H21M28.5 15C28.5 22.4558 22.4558 28.5 15 28.5C7.54416 28.5 1.5 22.4558 1.5 15C1.5 7.54416 7.54416 1.5 15 1.5C22.4558 1.5 28.5 7.54416 28.5 15Z" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function Heart({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(9.600 9.600) scale(0.96000 0.96000)">
      <path d="M15 26.69L13.19 25.04C6.75 19.2 2.5 15.35 2.5 10.62C2.5 6.78 5.53 3.75 9.38 3.75C11.55 3.75 13.64 4.76 15 6.36C16.36 4.76 18.45 3.75 20.62 3.75C24.47 3.75 27.5 6.78 27.5 10.62C27.5 15.35 23.25 19.2 16.81 25.05L15 26.69Z" stroke="currentColor" strokeWidth={strokeW} strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function Mail({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(7.502 13.502) scale(0.91653 0.87480)">
      <path d="M31.5 1.5V22.5H4.5V1.5H31.5ZM4.5 1.5L18 13.5L31.5 1.5" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function MapPin({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(13.502 10.502) scale(0.87480 0.88966)">
      <path d="M22.5 12C22.5 21 12 28.5 12 28.5C12 28.5 1.5 21 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12Z" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      <path d="M16.5 12C16.5 14.4853 14.4853 16.5 12 16.5C9.51472 16.5 7.5 14.4853 7.5 12C7.5 9.51472 9.51472 7.5 12 7.5C14.4853 7.5 16.5 9.51472 16.5 12Z" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function Menu({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(8.000 15.000) scale(1.00000 0.85714)">
      <path d="M0 1.5H32M0 10.5H32M0 19.5H32" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

// Animated hamburger <-> close morph, used where the toggle itself needs to
// reflect open/closed state (e.g. the navbar's mobile menu button) rather
// than swapping between two separate static icons.
export function MenuToggle({ open, size = 24, className, strokeWidth: sw }: IconProps & { open: boolean }) {
  const strokeW = sw ?? (size / 24) * 1.5;
  const lineProps = {
    stroke: "currentColor",
    strokeWidth: strokeW,
    strokeLinecap: "round" as const,
    vectorEffect: "non-scaling-stroke" as const,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <line
        {...lineProps}
        x1="8" y1="15" x2="40" y2="15"
        style={{
          transformOrigin: "24px 15px",
          transform: open ? "translateY(9px) rotate(45deg)" : "none",
          transition: "transform 300ms cubic-bezier(0.65,0,0.35,1)",
        }}
      />
      <line
        {...lineProps}
        x1="8" y1="24" x2="40" y2="24"
        style={{
          transformOrigin: "24px 24px",
          opacity: open ? 0 : 1,
          transform: open ? "scaleX(0)" : "scaleX(1)",
          transition: "opacity 150ms ease, transform 150ms ease",
        }}
      />
      <line
        {...lineProps}
        x1="8" y1="33" x2="40" y2="33"
        style={{
          transformOrigin: "24px 33px",
          transform: open ? "translateY(-9px) rotate(-45deg)" : "none",
          transition: "transform 300ms cubic-bezier(0.65,0,0.35,1)",
        }}
      />
    </svg>
  );
}

export function Minus({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(13.502 23.328) scale(0.99977 0.44800)">
      <path d="M0 1.5H21" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function Pencil({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(10.502 10.502) scale(0.88158 0.88158)">
      <path d="M1.5 29.1213H6L28.5 6.62132L24 2.12132L1.5 24.6213V29.1213Z" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function Plus({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(13.502 13.502) scale(0.99977 0.99977)">
      <path d="M0 10.5H21M10.5 0V21" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function Search({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(10.502 10.502) scale(0.91321 0.91321)">
      <path d="M28.5 28.5L19.4246 19.4246M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12Z" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function Trash2({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(10.502 7.502) scale(0.99982 0.95223)">
      <path d="M0 4.5H13.5M27 4.5H13.5M13.5 0V4.5M13.5 4.5H22.5V30H4.5V4.5H13.5ZM10.5 25.5V9M16.5 9V25.5" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function User({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(13.502 10.502) scale(0.87480 0.94720)">
      <path d="M22.5 28.5C22.5 22.701 17.799 18 12 18C6.20101 18 1.5 22.701 1.5 28.5M18 7.5C18 10.8137 15.3137 13.5 12 13.5C8.68629 13.5 6 10.8137 6 7.5C6 4.18629 8.68629 1.5 12 1.5C15.3137 1.5 18 4.18629 18 7.5Z" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function X({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(13.502 13.502) scale(0.90805 0.90805)">
      <path d="M1.06066 1.06066L11.5607 11.5607M22.0607 22.0607L11.5607 11.5607M22.0607 1.06066L11.5607 11.5607M1.06066 22.0607L11.5607 11.5607" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function Maximize({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M8 16V8H16M32 8H40V16M40 32V40H32M16 40H8V32"
        stroke="currentColor"
        strokeWidth={strokeW}
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}

export function Package({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(9.998 6.998) scale(0.87089 0.87195)">
      <path d="M16.5376 37.2613L31.5753 28.5111V11.0115L16 1.7613L1.5 11.0115V28.5111L16.5376 37.2613Z" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="square" vectorEffect="non-scaling-stroke"/>
      <path d="M16.5 37.2613V20.2613" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      <path d="M1.5 11.2613L16.5 20.2613L31.5 11.2613" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      <path d="M8.5 6.2613L23.5 15.2613" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function ShieldCheck({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(9.998 6.998) scale(0.90333 0.91689)">
      <path d="M29.5 20.8787C29.5 33.1312 15.5 36.6308 15.5 36.6308C15.5 36.6308 1.5 33.3357 1.5 20.8787C1.5 17.9904 2.01256 7.39355 2.01256 7.39355L15.5 1.63117L28.9874 7.39355C28.9874 7.39355 29.5 17.9904 29.5 20.8787Z" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      <path d="M10.5 19.1312L13.8333 22.6312L20.5 15.6312" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="square" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function Truck({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(6.998 9.998) scale(0.86467 0.84648)">
      <path d="M23.6726 26.7606C23.6726 21.1849 23.6726 1.50005 23.6726 1.50005L1.5 1.5V26.7606C1.5 26.7606 5.21395 26.7606 6.62711 26.7606" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      <path d="M25.4908 26.7607H14.5817" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M33.3316 26.7607C34.7861 26.7607 38.7021 26.7607 38.7021 26.7607V16.6921C36.7337 14.2605 31.3087 7.85912 31.3087 7.85912C31.3087 7.85912 25.8289 7.66974 23.6725 7.66974" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      <path d="M29.1258 30.3969C31.1334 30.3969 32.7608 28.7688 32.7608 26.7605C32.7608 24.7522 31.1334 23.1241 29.1258 23.1241C27.1182 23.1241 25.4908 24.7522 25.4908 26.7605C25.4908 28.7688 27.1182 30.3969 29.1258 30.3969Z" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M10.9452 30.3969C12.9535 30.3969 14.5816 28.7688 14.5816 26.7605C14.5816 24.7522 12.9535 23.1241 10.9452 23.1241C8.9369 23.1241 7.30884 24.7522 7.30884 26.7605C7.30884 28.7688 8.9369 30.3969 10.9452 30.3969Z" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function GearWrench({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(6.400 6.400) scale(1.600 1.600)">
        {/* Both sub-shapes now share the same round cap/join as the rest of
            this icon set (Truck, ShieldCheck) — the gear teeth's square cap
            and the wrench's bevel join were a mismatched pair that read as
            two different stroke weights even though the numeric strokeWidth
            was already identical between them. */}
        <g stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke">
          <path d="M8.86 20.66V17.94C8.37 17.79 7.9 17.6 7.46 17.36L5.54 19.28"/>
          <path d="M1.22 8.86H3.94C4.09 8.37 4.28 7.9 4.52 7.46L2.6 5.54"/>
          <path d="M5.54 2.6L7.46 4.52C7.9 4.28 8.37 4.09 8.86 3.94V1.22"/>
          <path d="M2.6 16.34L4.52 14.42C4.28 13.98 4.09 13.51 3.94 13.02H1.22"/>
          <path d="M13.02 1.22V3.94C13.51 4.09 13.98 4.28 14.42 4.52L16.34 2.6"/>
          <path d="M19.28 5.54L17.36 7.46C17.6 7.9 17.79 8.37 17.94 8.86H20.66"/>
          <path d="M17.36 7.46L19.28 5.54C18.52 4.37 17.52 3.36 16.34 2.6L14.42 4.52"/>
          <path d="M8.86 17.94V20.66C9.53 20.8 10.23 20.88 10.94 20.88C11.65 20.88 12.35 20.8 13.02 20.66"/>
          <path d="M4.52 14.42L2.6 16.34C3.36 17.51 4.36 18.52 5.54 19.28L7.46 17.36"/>
          <path d="M3.94 8.86H1.22C1.08 9.53 1 10.23 1 10.94C1 11.65 1.08 12.35 1.22 13.02H3.94"/>
          <path d="M13.02 3.94V1.22C12.35 1.08 11.65 1 10.94 1C10.23 1 9.53 1.08 8.86 1.22V3.94"/>
          <path d="M20.66 13.02C20.8 12.35 20.88 11.65 20.88 10.94C20.88 10.23 20.8 9.53 20.66 8.86H17.94"/>
          <path d="M7.46 4.52L5.54 2.6C4.37 3.36 3.36 4.36 2.6 5.54L4.52 7.46"/>
        </g>
        <path
          d="M11.19 7.98C11.97 7.98 12.76 8.28 13.35 8.88C14.16 9.69 14.42 10.83 14.14 11.85L19.08 16.79C19.67 17.38 19.67 18.35 19.08 18.94C18.78 19.24 18.39 19.38 18 19.38C17.61 19.38 17.22 19.23 16.92 18.94L11.98 14C11.72 14.07 11.44 14.11 11.17 14.11C10.39 14.11 9.6 13.81 9 13.21C8.14 12.35 7.9 11.11 8.27 10.03L9.59 11.35C9.85 11.61 10.19 11.74 10.53 11.74C10.87 11.74 11.21 11.61 11.47 11.35C11.99 10.83 11.99 9.98 11.47 9.46L10.15 8.14C10.48 8.03 10.82 7.97 11.16 7.97"
          stroke="currentColor"
          strokeWidth={strokeW}
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect="non-scaling-stroke"
        />
      </g>
    </svg>
  );
}

export function Wrench({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(9.000 9.000) scale(0.94803 0.94803)">
      <path d="M18.9871 7.88324C17.6808 9.15603 17.6672 11.2511 18.9568 12.5408C20.223 13.8069 22.2717 13.8202 23.5542 12.5706L29.3214 6.9513C30.0971 8.66552 30.332 10.5754 29.9947 12.4265C29.6575 14.2776 28.7641 15.9819 27.4336 17.3124C26.1032 18.6429 24.3988 19.5363 22.5477 19.8735C20.6967 20.2108 18.7867 19.9759 17.0725 19.2002L7.08654 29.1861C5.80854 30.4641 3.7365 30.4641 2.4585 29.1861C1.18049 27.9081 1.1805 25.836 2.45852 24.558L12.4445 14.5722C11.6688 12.858 11.4339 10.948 11.7712 9.09695C12.1084 7.24587 13.0018 5.54153 14.3323 4.21106C15.6628 2.8806 17.3671 1.9872 19.2182 1.64993C21.0693 1.31265 22.9792 1.54753 24.6934 2.32324L18.9871 7.88324Z" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function Building2({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(11.143 9.600) scale(0.85714 0.85714)">
      <path d="M6 32.1V1.5H24V32.1M1.5 32.1H28.5M10.5 7.5H12M18 7.5H19.5M10.5 13.5H12M18 13.5H19.5M10.5 19.5H12M18 19.5H19.5M12 32.1V25.5H18V32.1" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function Cake({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(9.600 10.560) scale(0.96000 0.96000)">
      <path d="M15 1V5.5" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      <path d="M13.3 3.2C13.3 2 15 0.5 15 0.5C15 0.5 16.7 2 16.7 3.2C16.7 4 15.9 4.6 15 4.6C14.1 4.6 13.3 4 13.3 3.2Z" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M5 26V13C5 11 7 9.5 9.5 9.5H20.5C23 9.5 25 11 25 13V26H5Z" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M5 18.5H25" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      <path d="M2 26H28" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function CheckCircle2({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(9.600 9.600) scale(0.96000 0.96000)">
      <circle cx="15" cy="15" r="13.5" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      <path d="M9 15.5L13 19.5L21 10.5" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function FileDown({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(12.480 9.600) scale(0.96000 0.96000)">
      <path d="M14 1.5H3V28.5H21V8.5L14 1.5Z" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M14 1.5V8.5H21" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M12 14V23M12 23L8.5 19.5M12 23L15.5 19.5" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function ShoppingCart({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(9.600 10.909) scale(0.87273 0.87273)">
      <path d="M1.5 1.5H6L9.6 19.5C9.9 21 11.2 22 12.7 22H25.5C26.9 22 28.1 21.1 28.5 19.7L31.5 9H7.5" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <circle cx="13.5" cy="27" r="2.25" fill="currentColor"/>
      <circle cx="24" cy="27" r="2.25" fill="currentColor"/>
      </g>
    </svg>
  );
}

export function Filter({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(10.000 11.000) scale(1.0 1.0)">
      <path d="M0 0H28L17 15V26L11 22V15L0 0Z" stroke="currentColor" strokeWidth={strokeW} strokeLinejoin="round" strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function SlidersHorizontal({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(9.600 10.700) scale(1.06667 1.06667)">
      <path d="M0 3H15.5M20.5 3H27M0 13H6.5M11.5 13H27M0 23H16.5M21.5 23H27" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      <circle cx="18" cy="3" r="2.5" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      <circle cx="9" cy="13" r="2.5" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      <circle cx="19" cy="23" r="2.5" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function Store({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(9.600 11.040) scale(0.96000 0.96000)">
      <path d="M1.5 9L4 1.5H26L28.5 9M1.5 9V25.5H28.5V9M1.5 9C1.5 11 3 12.5 5 12.5C7 12.5 8.5 11 8.5 9C8.5 11 10 12.5 12 12.5C14 12.5 15.5 11 15.5 9C15.5 11 17 12.5 19 12.5C21 12.5 22.5 11 22.5 9C22.5 11 24 12.5 26 12.5C27.5 12.5 28.5 11 28.5 9" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M12 25.5V17H18V25.5" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function UtensilsCrossed({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(9.600 9.600) scale(0.90000 0.90000)">
      <path d="M6 2V10M11 2V10M16 2V10" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      <path d="M6 10C6 12.5 8.5 13.5 11 13.5L28 30.5" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M25 1.5C21 3.5 19 7.5 19 10.5C19 12.5 20.3 13.8 22 13.8L4 30.5" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function Phone({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(9.600 9.600) scale(1.20000 1.20000)">
      <path d="M6 3C4 3 2 5 2 8C2 15 9 22 16 22C19 22 21 20 21 18C21 17.3 20.6 16.7 20 16.4L16.3 14.3C15.7 14 15 14.1 14.6 14.6L13.3 16C11.3 14.8 9.2 12.7 8 10.7L9.4 9.4C9.9 9 10 8.3 9.7 7.7L7.6 4C7.3 3.4 6.7 3 6 3Z" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function WhatsApp({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(9.600 9.600) scale(0.96000 0.96000)">
      <path d="M15 27C21.6274 27 27 21.6274 27 15C27 8.37258 21.6274 3 15 3C8.37258 3 3 8.37258 3 15C3 17.2145 3.60072 19.2891 4.64921 21.0687L3.5 27L9.5613 25.6947C11.2669 26.5288 13.0952 27 15 27Z" stroke="currentColor" strokeWidth={strokeW} strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M12.25 10.25C11.25 10.25 10.25 11.25 10.25 12.75C10.25 16.25 13.75 19.75 17.25 19.75C18.75 19.75 19.75 18.75 19.75 17.75C19.75 17.4 19.55 17.1 19.25 16.95L17.4 15.9C17.1 15.75 16.75 15.8 16.55 16.05L15.9 16.75C14.9 16.15 13.85 15.1 13.25 14.1L13.95 13.45C14.2 13.25 14.25 12.9 14.1 12.6L13.05 10.75C12.9 10.45 12.6 10.25 12.25 10.25Z" stroke="currentColor" strokeWidth={strokeW} strokeLinejoin="round" strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function Instagram({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(9.600 9.600) scale(0.96000 0.96000)">
      <rect x="3" y="3" width="24" height="24" rx="7" stroke="currentColor" strokeWidth={strokeW} strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <circle cx="15" cy="15" r="5.5" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      <circle cx="21.5" cy="8.5" r="1.3" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function Telegram({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(9.600 9.600) scale(1.20000 1.20000)">
      <path d="M15 10L11 14L17 20L21 4L3 11L7 13L9 19L12 15" stroke="currentColor" strokeWidth={strokeW} strokeLinejoin="round" strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

export function RefreshCw({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(6.857 6.857) scale(1.14286 1.14286)">
      <path d="M2 12a10 10 0 0 1 17-7.07L23 9" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M23 3v6h-6" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M22 12a10 10 0 0 1-17 7.07L1 15" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M1 21v-6h6" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}

// Container-type icons — used on product pages to show which packaging
// formats a machine handles (glass/tin/bucket/tray/pouch), matching the same
// hand-drawn line style as the rest of this file (viewBox 0 0 48 48,
// currentColor stroke, non-scaling-stroke).
export function Jar({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M20 6H28V9.5L31.5 14.5V39C31.5 40.7 30 42 28 42H20C18 42 16.5 40.7 16.5 39V14.5L20 9.5V6Z" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M20 6H28" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      <path d="M16.5 20H31.5" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
    </svg>
  );
}

export function Tin({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M11 13C11 10.5 16.9 8.5 24 8.5C31.1 8.5 37 10.5 37 13V35C37 37.5 31.1 39.5 24 39.5C16.9 39.5 11 37.5 11 35V13Z" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M11 13C11 15.5 16.9 17.5 24 17.5C31.1 17.5 37 15.5 37 13" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
    </svg>
  );
}

export function Bucket({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M12 17H36L33.3 39.4C33.1 40.9 31.9 42 30.5 42H17.5C16.1 42 14.9 40.9 14.7 39.4L12 17Z" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M10 17H38" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      <path d="M16 17C16 12.6 19.6 9 24 9C28.4 9 32 12.6 32 17" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
    </svg>
  );
}

export function Tray({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M8 20C8 18.3 9.3 17 11 17H37C38.7 17 40 18.3 40 20V29C40 30.7 38.7 32 37 32H11C9.3 32 8 30.7 8 29V20Z" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M13 17V13C13 11.9 13.9 11 15 11H33C34.1 11 35 11.9 35 13V17" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
    </svg>
  );
}

export function Pouch({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M14 10H34V16C39 20 40 26 38 32C36 38 30 41 24 41C18 41 12 38 10 32C8 26 9 20 14 16V10Z" stroke="currentColor" strokeWidth={strokeW} strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <path d="M14 10V6H34V10" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
    </svg>
  );
}

export function Eye({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M4 24C4 24 11.5 12 24 12C36.5 12 44 24 44 24C44 24 36.5 36 24 36C11.5 36 4 24 4 24Z" stroke="currentColor" strokeWidth={strokeW} strokeLinejoin="round" vectorEffect="non-scaling-stroke"/>
      <circle cx="24" cy="24" r="6" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
    </svg>
  );
}

export function EyeOff({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M8 10L40 38" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      <path d="M18.2 16.4C19.9 15.5 21.9 15 24 15C36.5 15 44 27 44 27C42.6 29.4 40.6 31.8 38.2 33.7M13.1 20.2C8.6 23.4 5.5 27 4 27C4 27 11.5 39 24 39C26.4 39 28.7 38.5 30.8 37.6" stroke="currentColor" strokeWidth={strokeW} strokeLinejoin="round" strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      <path d="M21 22.2C20.4 23 20 24 20 25C20 27.2 21.8 29 24 29C25.1 29 26.1 28.5 26.8 27.8" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
    </svg>
  );
}

export function AtSign({ size = 24, className, strokeWidth: sw }: IconProps) {
  const strokeW = sw ?? (size / 24) * 1.5;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g transform="translate(9.600 9.600) scale(0.96000 0.96000)">
      <circle cx="15" cy="15" r="5" stroke="currentColor" strokeWidth={strokeW} vectorEffect="non-scaling-stroke"/>
      <path d="M20 10v6.25a3.75 3.75 0 0 0 7.5 0v-1.25a12.5 12.5 0 1 0-4.9 9.93" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" vectorEffect="non-scaling-stroke"/>
      </g>
    </svg>
  );
}
